import { PartnerApi } from "../../api/partner.api";

export default function PersonDetail(props) {
  if (!("person" in props) || !props.person) {
    return <></>;
  }

  const { person } = props;

  return (
    <>
      {person.photo_available ? (
        <>
          <img
            className="mw-100 mb-4"
            style={{
              aspectRatio: "1 / 1",
              objectFit: "contain",
            }}
            src={PartnerApi.url + "/person/" + person.person_id + "/image.jpg"}
            alt={person.first_name + " " + person.last_name}
          />
        </>
      ) : (
        <>
          <img
            className="mw-100 mb-4"
            style={{
              aspectRatio: "1 / 1",
              objectFit: "contain",
            }}
            src={"/assets/media/osoba.jpg"}
          />
        </>
      )}
      <div>
        <strong>
          {person.first_name} {person.last_name}
        </strong>

        <div className="mt-2">{person.position}</div>
        <div className="mt-2">
          <a href={"callto:" + person.phone}>{person.phone}</a>
        </div>
        <div className="mt-2">
          <a href={"mailto:" + person.email}>{person.email}</a>
        </div>
      </div>
    </>
  );
}
